<template>
    <div class="vat-toggle">
      <label class="toggle-label">
        <input 
          type="checkbox" 
          :checked="showVAT" 
          @change="handleToggle"
          class="toggle-input"
        />
        <span class="toggle-slider"></span>
        <span class="toggle-text">Vis priser med moms (+25%)</span>
      </label>
      <div class="vat-info">
        <img 
          src="@/assets/images/icons/Information.svg" 
          alt="Information" 
          class="info-icon"
        />
        <div class="info-tooltip">
          Vis alle omsætningstal med 25% moms. Lønprocent beregnes stadig på basis af omsætning ekskl. moms.
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { computed } from 'vue';
  import { useStore } from 'vuex';
  
  export default {
    name: 'VATToggle',
    setup() {
      const store = useStore();
      
      const showVAT = computed(() => store.state.showVat);
      
      const handleToggle = () => {
        store.dispatch('toggleVAT');
      };
      
      return {
        showVAT,
        handleToggle
      };
    }
  };
  </script>
  
  <style scoped>
  .vat-toggle {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    background: var(--card-background);
    border-radius: 8px;
    box-shadow: 0 2px 4px var(--shadow-color);
  }
  
  .toggle-label {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    cursor: pointer;
    user-select: none;
    position: relative;
  }
  
  .toggle-input {
    opacity: 0;
    width: 0;
    height: 0;
    position: absolute;
  }
  
  .toggle-slider {
    position: relative;
    display: inline-block;
    width: 48px;
    height: 24px;
    background-color: var(--light-grey);
    border-radius: 24px;
    transition: background-color 0.3s ease;
  }
  
  .toggle-slider::after {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    left: 3px;
    top: 3px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s ease;
  }
  
  .toggle-input:checked + .toggle-slider {
    background-color: var(--primary-text-color);
  }
  
  .toggle-input:checked + .toggle-slider::after {
    transform: translateX(24px);
  }
  
  .toggle-text {
    color: var(--primary-text-color);
    font-size: 0.95rem;
    font-weight: 500;
  }
  
  .vat-info {
    position: relative;
    display: inline-block;
  }
  
  .info-icon {
    width: 18px;
    height: 18px;
    cursor: help;
    opacity: 0.7;
    transition: opacity 0.2s;
  }
  
  .info-icon:hover {
    opacity: 1;
  }
  
  .info-tooltip {
    visibility: hidden;
    position: absolute;
    z-index: 1000;
    bottom: 125%;
    right: 0;
    transform: translateX(0);
    padding: 0.75rem 1rem;
    background-color: var(--primary-text-color);
    color: white;
    text-align: left;
    border-radius: 6px;
    font-size: 0.9rem;
    white-space: normal;
    line-height: 1.4;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    opacity: 0;
    transition: opacity 0.2s, visibility 0.2s;
    width: 320px;
  }
  
  .info-tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    right: 10px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--primary-text-color) transparent transparent transparent;
  }
  
  .vat-info:hover .info-tooltip {
    visibility: visible;
    opacity: 1;
  }
  
  @media (max-width: 768px) {
    .vat-toggle {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .info-tooltip {
      white-space: normal;
      max-width: 250px;
    }
  }
  </style>